<mat-spinner class="medium-centered-spinner" 
              [strokeWidth]="3" 
              [diameter]="40">
</mat-spinner>